<template>
  <AdaptiveSheet class="recordVideoTakePicture main" :class="{ 'camera-popup-native': isNativePlatform }" :backdrop="false" :tablet-fullscreen="false" :swipe-to-close="false" full-screen
    @close="stopPreviewRecording()">
    <div ref="cameraPreviewWeb">
      <f7-link sheet-close popup-close icon-ios="f7:xmark" icon-md="material:clear" class="recordVideoClose"></f7-link>
      <video autoplay="autoplay" id="videoRecorder" ref="videoRecorder" v-show="!isNativePlatform"></video>

      <f7-fab v-if="flashModes && flashModes.length > 0" position="left-bottom" class="switch" color="auto"
        @click="setFlashMode()">
        <f7-icon v-if="flashMode === 'on'" ios="f7:bolt" md="material:flash_on"></f7-icon>
        <f7-icon v-else-if="flashMode === 'auto'" ios="f7:bolt_badge_a" md="material:flash_auto"></f7-icon>
        <f7-icon v-else-if="flashMode === 'off'" ios="f7:bolt_slash" md="material:flash_off"></f7-icon>
        <f7-icon v-else-if="flashMode === 'torch'" ios="f7:lightbulb" md="material:flashlight_on"></f7-icon>
        <f7-icon v-else-if="flashMode === 'red-eye'" ios="f7:eye" md="material:visibility" color="red"></f7-icon>
      </f7-fab>
      <f7-fab v-if="torchSupported" position="left-bottom" class="switch switch-torch" color="auto" @click="toggleTorch">
        <f7-icon :ios="torchActive ? 'f7: bolt' : 'f7:bolt_slash'"
          :md="torchActive ? 'f7: bolt_slash' : 'material:flash_off'" color="white"></f7-icon>
      </f7-fab>

      <f7-fab position="center-bottom" color="auto" @click="startPreviewRecording()" @taphold="startPreviewRecording()"
        v-if="!isMediaRecording">
        <f7-icon ios="f7:videocam_circle_fill" md="material:videocam"></f7-icon>
      </f7-fab>
     
      <f7-fab position="center-bottom" color="red" @click="stopPreviewRecording()" v-if="isMediaRecording">
        <f7-icon ios="f7:stop_fill" md="material:stop"></f7-icon>
      </f7-fab>
      <f7-fab position="right-bottom" color="primary" @click="switchCamera()"
        v-if="cameras && cameras.length > 1">
        <f7-icon ios="f7:camera_rotate_fill" md="f7:camera_rotate_fill"></f7-icon>
      </f7-fab>
      <f7-fab position="right-bottom" color="auto" @click="cameraCapture()"
        v-if="!isMediaRecording">
        <f7-icon ios="f7:camera_fill" md="material:photo_camera"></f7-icon>
      </f7-fab>
    </div>
  </AdaptiveSheet>
</template>
<style lang="css">
#recordMediaPopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  background: transparent;
}

.recordVideoTakePicture {
  z-index: 2147483646 !important;
}

.recordVideoTakePicture.main.camera-popup-native {
  background: transparent;
  box-shadow: none;
}

/* video#video {
  object-fit: cover;
  height: 100%;
  width: 100%;
} */

.recordVideoNative,
.recordVideoClose {
  position: absolute;
  right: 16px;
  top: 16px;
  color: inherit;
  margin-right: auto;
}

.recordVideoNative {
  z-index: 9999;
}

.button-container {
  position: fixed;
  bottom: 16px;
  /* left: 0; */
  width: 100%;
  display: flex;
  justify-content: space-around;
  z-index: 9999;

  /* padding: 16px; */
}

#videoRecorder {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fab-button a {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

.fab-buttons a {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}
</style>
<script setup>
import { storeToRefs } from "pinia";
import AdaptiveSheet from "./common/AdaptiveSheet.vue";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useAttachmentStore } from "../js/pinia-stores/attachmentStore.js";
import { useTabletScreen } from "../js/composables/useMediaQuery.js";
import { useAttachDocs } from "../js/composables/useAttachDocs.js";
import { useCamera } from "../js/composables/useCamera.js";

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const authStore = useAuthStore();
const attachmentStore = useAttachmentStore();
const { profile, document: authDocument, isNativePlatform, locale } = storeToRefs(authStore);
const { documentsUrl } = storeToRefs(attachmentStore);
const isTablet = useTabletScreen().matches;

const { attachFileOpenActions: attachDocsActions, setAttachment: attachDocsSetAttachment, removeDoc, getFileMimeType, photoList, documentsUrl: docsUrl } = useAttachDocs({
  isTablet,
  profile,
  documentsUrl,
});

const {
  isMediaRecording,
  flashModes,
  flashMode,
  torchSupported,
  torchActive,
  cameras,
  openPreviewCamera,
  startPreviewRecording,
  stopPreviewRecording,
  switchCamera,
  setFlashMode,
  toggleTorch,
  cameraCapture,
} = useCamera({ setAttachment: attachDocsSetAttachment });
</script>
